import { workPreparationLoader } from './loaders';

const WorkPreparationsPage = () => import('./views/WorkPreparationsPage.vue');

export default [
  {
    path: '/work-preparations',
    name: 'work-preparations',
    component: WorkPreparationsPage,
    props: {
      context: workPreparationLoader,
    },
    meta: {
      title: 'workPreparation.pageTitle',
      logicalModule: 'work-preparations',
    },
  },
];
